import GameState from "../enum/gamestate";
import { ApiGame, ApiGameInvite, ApiSeat } from "../types/apigame";

export function getSeatObjectForInvite(invite: ApiGameInvite): ApiSeat {
    const userId = invite.user?.id ?? -invite.id;
    const name = invite.user?.name ?? invite.invitedUser?.email ?? 'Invited player';

    // Invited players do not have seats yet, so use proxy seat objects to render them in player lists.
    return {
        id: -invite.id,
        cardsNextTurn: 0,
        color: invite.user?.favoriteColor ?? 0,
        seatNumber: Number.MAX_SAFE_INTEGER,
        unitBonus: 0,
        user: {
            id: userId,
            name,
            avatar: invite.user?.avatar,
        },
        userId,
        name,
        accepted: false,
        isAlive: true,
    };
}

export function getSeatObjectsFromPendingInvites(game: ApiGame): ApiSeat[] {
    if (game.state !== GameState.Created) {
        return [];
    }

    const seatedUserIds = new Set(game.seats.map((seat) => seat.userId));

    return game.invites
        .filter(
            (invite) => !invite.user || !seatedUserIds.has(invite.user.id),
        )
        .map(getSeatObjectForInvite);
}

export function getSeatObjectsAndInvitedPlayers(game: ApiGame): ApiSeat[] {
    return [
        ...game.seats,
        ...getSeatObjectsFromPendingInvites(game),
    ];
}
